import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBasePlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.99994 3.33331V8M7.99994 8V12.6666M7.99994 8H3.33325M7.99994 8H12.6666",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconBasePlus;
